export default __webpack_public_path__ + "static/media/phone-example.8284dc8b.png";